export default "__VITE_ASSET__DPhyh574__"